<script setup lang="ts">
const { closeDialog, openDialog } = useDialog()
const localePath = useLocalePath()
const { cookies, acceptAll, rejectAll, save, toggleCookie } =
  useOneTrustCookies()
const { dispatchCookieBannerEvent } = useGANavigationEvents()

const modalId = 'modal-cookie-banner'
const cookieBannerCenter = 'modal-cookie-banner-center'

const openCookieSettings = () => {
  dispatchCookieBannerEvent('preferences')
  openDialog(cookieBannerCenter)
}

const continueWithoutAcceptingCookies = () => {
  rejectAll()
  dispatchCookieBannerEvent('deny_all')
  closeDialog(modalId)
}

const acceptAllCookies = () => {
  acceptAll()
  dispatchCookieBannerEvent('accept_all')
  closeDialog(modalId)
}

const saveAllowedCookies = () => {
  save()
  dispatchCookieBannerEvent('preferences_saved')
  closeDialog(modalId)
}
</script>
<template>
  <OrganismsModal
    :id="modalId"
    hide-close-button
    auto-height
    position="center"
    with-overlay
    class="z-[100]"
    force-global-theme
    prevent-lock-body-scroll
  >
    <template #body>
      <div class="bg-primitives-white">
        <div class="mb-6 flex justify-end">
          <AtomsCta
            anatomy="link"
            :icon-show-default="false"
            class="text-link-7"
            @click="continueWithoutAcceptingCookies()"
          >
            <template #label>
              {{ $ts('cookieBanner.continueWithoutAccepting') }}
            </template>
          </AtomsCta>
        </div>
        <UtilsMarkdown
          class="text-light-6 mb-6"
          :content="
            $ts('cookieBanner.description', {
              url: localePath('/legal/cookie-policy'),
            })
          "
        />
        <div
          class="flex flex-col-reverse items-center justify-center gap-6 md:flex-row"
        >
          <AtomsCta anatomy="link" @click="openCookieSettings()">
            <template #label>{{ $ts('cookieBanner.settings') }}</template>
          </AtomsCta>
          <AtomsCta @click="acceptAllCookies()">
            <template #label>{{ $ts('cookieBanner.acceptAll') }}</template>
          </AtomsCta>
        </div>
      </div>
      <CookieBannerCenter
        :cookies
        @on-accept-all="acceptAllCookies"
        @on-save="saveAllowedCookies"
        @on-toggle-cookie="toggleCookie"
      />
    </template>
  </OrganismsModal>
</template>
